import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, UrlTree, Router, CanActivateFn } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { HelpersService } from "../helpers-service/helpers.service";
import { ColumnDataLayoutService } from "../column-data-layout-services/column-data-layout.service";
import { MappingOfStatusesService } from "../mapping-of-statuses-service/mapping-of-statuses.service";
import { DashboardsService } from "../dashboards-service/dashboards.service";
import { CardDisplayService } from "../../shared/card-display/card-display.service";
import { isJobsBilling } from "@app/views-interfaces/ApplicationType.enum";
import { JobsBillingCard } from "@app/views-interfaces/jobs-billing-card.interface";
import { TaxprepT1Card } from "@app/views-interfaces";

export const cardIdGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> => {
    const router = inject(Router);
    const columnDataLayoutService = inject(ColumnDataLayoutService);
    const dashboardsService = inject(DashboardsService);
    const helpersService = inject(HelpersService);
    const mappingOfStatusesService = inject(MappingOfStatusesService);
    const cardDisplayService = inject(CardDisplayService);

    const validate = async (route: ActivatedRouteSnapshot) => {
        if (!helpersService.stepsMerged) {
            await helpersService.mergeSteps();
        }
        const card = cardDisplayService.getCardById(route.params.cardId);
        if (card) {
            const currentDashboard = await dashboardsService.getCurrentDashboard();
            if (currentDashboard) {
                let status: string;
                if (isJobsBilling(currentDashboard.ApplicationType)) {
                    status = (card as JobsBillingCard).job.statusId;
                } else {
                    status = (card as TaxprepT1Card).return?.statusId;
                }
                const step = mappingOfStatusesService.getStepFromStatusId(status);

                let subRoute = "active";
                if (step?.State) {
                    subRoute = step.State === "notStarted" ? "not-started" : step.State;
                }

                if (router.currentNavigation()?.finalUrl?.toString().indexOf(subRoute) > 1) {
                    return true;
                } else {
                    return router.createUrlTree(["/card-view", currentDashboard.Id, subRoute, route.params.cardId]);
                }
            } else {
                return true;
            }
        } else {
            return true;
        }
    };

    if (columnDataLayoutService.cardsAreLoaded) {
        return await validate(route);
    } else {
        await firstValueFrom(columnDataLayoutService.loadCardsFromCacheEvent$);
        return await validate(route);
    }
};
